import React, { Fragment } from "react";
//imagenes eliminadas
/*
import OwlTestimonial from "../layout/OwlTestimonial";
import blog1 from "../static/images/Blog-1.png";
import blog2 from "../static/images/Blog-2.png";
import blog3 from "../static/images/Blog-3.png";
import canada from "../static/images/canada-color.png";
import childre from "../static/images/children_believe_logo-color.png";
import cep from "../static/images/cep-color.png";
import heifer from "../static/images/heifer-color.png";
import empuje from "../static/images/empuje.png";
import user_testimonial from "../static/images/user_testimonial.png";
import inatec from "../static/images/inatec.png";
import empuje from "../static/images/LOGO_EMPUJE2.png";

import { faAlignCenter } from "@fortawesome/free-solid-svg-icons";
import { FormatAlignCenter } from "@material-ui/icons";
*/
import HeaderHome from "../layout/HeaderHome";
import SliderHome from "../layout/SliderHome";
import FooterHome from "../layout/FooterHome";
import SliderAliados from "../layout/SliderAliados";

import iconounclic from "../static/images/02-icono-un-clic.svg";
import etaoasdeproceso from "../static/images/02-iconos-etaoas-de-proceso.svg";
import iconocomunicate from "../static/images/02-icono-comunicate.svg";
import iconoprogramainsignias from "../static/images/02-icono-programa-insignias.svg";
import iconorecomendaciones from "../static/images/02-icono-recomendaciones.svg";

import iconencuentra from "../static/images/icon-encuentra.svg";
import iconodesarrollate from "../static/images/icono-desarrollate.svg";
import icononetworking from "../static/images/icono-networking.svg";
import iconogrupo from "../static/images/icono-grupo.svg";
import iconoenterate from "../static/images/icono-enterate.svg";
//import model003 from "../static/images/model003.png";
//import model002 from "../static/images/model002.png";

import mision from "../static/images/Home/FOTO3.webp";

import testimonial_pic1 from "../static/images/Cesar-Herrera.png";
import testimonial_pic2 from "../static/images/Jennifer-Hernandez.png";
import testimonial_pic3 from "../static/images/Alberto-Gonzalez.png";
import testimonial_pic4 from "../static/images/Ana-Garcia.png";
import testimonial_pic5 from "../static/images/Rosibel-Sanchez.png";
import testimonial_pic6 from "../static/images/Deyra-Mora.png";
import gear_wheel from "../static/images/gear-wheel.svg";

import "../static/css/homeresponsive.css";
//New Home
import model003 from "../static/images/Home/FOTO1.webp";
import model002 from "../static/images/Home/FOTO2.webp";
// import "../static/js/vendors/mmenu-light";

function Home() {
  const images = [
    {
      url: model003,
      tittle: "KREZCO",
      content:
        "El punto de encuentro entre jóvenes talento, empresas de prestigio y centros de formación profesional",
    },
    {
      url: model002,
      tittle: "KREZCO",
      content:
        "El punto de encuentro entre jóvenes talento, empresas de prestigio y centros de formación profesional",
    },
  ];

  return (
    <Fragment>
      <HeaderHome></HeaderHome>

      <section id="hero" className="hero" style={{ padding: "0px !important" }}>
        <img src={gear_wheel} alt="" className="hero__gear rotate"></img>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-10 px-0">
              <SliderHome images={images}></SliderHome>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="socios">
        <div className="container">
          <div className="row seven-cols">
            *
            <div className="col">
              <a href="https://www.canada.ca/en.html">
                <img src={canada} alt="canada"></img>
              </a>
            </div>
            <div className="col ln-border">
              <a href="https://childrenbelieve.ca/">
                <img src={childre} alt="childre"></img>
              </a>  
            </div>
            <div className="col text-right">
              <span className="title">SOCIOS</span>
            </div>
            <div className="col c-13">
              <a href="https://cep.empuje.org/">
                <img src={cep} alt="cep"></img>
              </a>
            </div>
            <div className="col c-13">
              <a href="https://www.heifer.org/">
                <img src={heifer} alt="heifer"></img>
              </a>
            </div>
            <div className="col c-13">
              <a href="https://www.tecnacional.edu.ni/">
                <img
                  src={inatec}
                  alt="inatec"
                  style={{ width: "130px", height: "85px" }}
                ></img>
              </a>
            </div>
          </div>
        </div>
      </section> */}
      <section className="comunidad">
        <div className="container">
          <div className="title">Sé parte de la comunidad KREZCO</div>
          <div className="sub-title">Un espacio diverso e inclusivo.</div>

          <div className="row justify-content-center mt-5">
            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={iconencuentra} alt="iconencuentra"></img>
                <h3>
                  Encuentra ofertas de <span>empleo, pasantía, freelance</span>{" "}
                  y voluntariado.
                </h3>
                <p>
                  Postúlate para las vacantes que mejor se adapten a tus
                  necesidades.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={iconodesarrollate} alt="iconodesarrollate"></img>
                <h3>
                  Desarróllate con cursos <span>y capacitaciones</span>
                </h3>
                <p>
                  Postúlate para las vacantes que mejor se adapten a tus
                  necesidades.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={icononetworking} alt="icononetworking"></img>
                <h3>Networking</h3>
                <p>
                  Conecta con tu red y construye relaciones profesionales
                  perdurables.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={iconogrupo} alt="iconogrupo"></img>
                <h3>Únete a grupos</h3>
                <p>Forma parte de grupos con intereses en común.</p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={iconoenterate} alt="iconoenterate"></img>
                <h3>
                  Entérate y asiste <span>a eventos exclusivos</span>
                </h3>
                <p>Ferias vocacionales, ferias de empleo, entre otros.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mision" id="sectionmision">
        <div className="container">
          <div className="row bg-box">
            <div className="col-md-6 one-half">
              <img src={mision} alt="mision"></img>
            </div>

            <div className="col-md-6">
              <div className="content">
                <div className="title">Sobre KREZCO:</div>

                <p>
                  KREZCO es una plataforma de Children Believe enfocada en
                  facilitar más oportunidades de acceso a empleo a jóvenes en
                  igualdad de género.
                </p>

                <p>
                  Motivamos e impulsamos a la juventud a ser parte de la
                  comunidad KREZCO para desarrollar sus capacidades y
                  habilidades, estar activos en el mundo laboral, mejorando su
                  calidad de vida a través del aprendizaje, el logro de sus
                  metas y perseguir sus sueños
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="experiencia">
        <div className="container">
          <div className="title">
            A través de la tecnología te ayudamos{" "}
            <span>a que tu búsqueda sea una experiencia </span>facíl y dinámica
          </div>

          <div className="row">
            <div className="col">
              <img src={iconounclic} alt="iconounclic"></img>
              <p>Aplica a una vacante con un sólo clic.</p>
            </div>

            <div className="col">
              <img src={etaoasdeproceso} alt="etaoasdeproceso"></img>
              <p>Sigue de cerca todas las etapas de tu proceso de selección.</p>
            </div>

            <div className="col">
              <img src={iconocomunicate} alt="iconocomunicate"></img>
              <p>
                Comunícate directamente con las empresas y centros de formación.
              </p>
            </div>

            <div className="col">
              <img
                src={iconoprogramainsignias}
                alt="iconoprogramainsignias"
              ></img>
              <p>Forma parte del programa de insignias.</p>
            </div>

            <div className="col">
              <img src={iconorecomendaciones} alt="iconorecomendaciones"></img>
              <p>Solicita y recibe recomendaciones para tus aplicaciones.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="aliados">
        <div className="container">
          <div className="title">Conoce y conéctate con nuestros aliados</div>
          <div className="row">
            <SliderAliados></SliderAliados>
          </div>
        </div>
      </section>

      <section className="testimonials-slider" id="carruseltestimonial">
        <div className="title">Testimoniales</div>
        <div className="sub-title">Compartiendo nuestra experiencia KREZCO</div>
        <div className="container">
          <div className="row">
            <div className="col-md-offset-2 col-md-8 mx-auto">
              <div
                id="carouselExampleControls"
                className="carousel slide"
                data-bs-ride="carousel"
                data-bs-interval="5000"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="testimonial">
                      <div className="pic">
                        <img
                          src={testimonial_pic1}
                          className="d-block w-50 "
                          alt="..."
                        ></img>
                      </div>
                      <div className="testimonial-content">
                        <p className="description">
                          César Herrera, a través de amigos conoce el proyecto
                          EMPUJE, son ellos quienes le dijeron que el proyecto
                          brindaba oportunidades para jóvenes como él que tienen
                          dificultades para acceder a un empleo. “En esta
                          comunidad es difícil estudiar y prepararse bien para
                          conseguir un empleo, el proyecto nos ha ensañado
                          mucho, sobre todo la confianza para saber que se puede
                          salir adelante”.
                        </p>

                        <p className="description">
                          Cesar es un joven de 24 años que realiza arreglos
                          florales en su comunidad Samulalí #2 de San Ramón,
                          Matagalpa. Con EMPUJE Cesar logró identificar donde
                          estaban las oportunidades en su comunidad para iniciar
                          un emprendimiento que tuviera acogida “con el proyecto
                          hice un plan de negocios para hacer snacks, porque lo
                          de flores es muy caro, y vi que en la comunidad no hay
                          golosinas, lo que hago es comprar plátanos y los pongo
                          a freír, empaco y vendo, la gente viene a mi casa a
                          comprar, pero también vendo en la iglesia, tengo
                          bastantes compradores”
                        </p>
                        <p className="description">
                          Manifiesta que las capacitaciones han sido muy
                          importantes para empezar el negocio y administrarlo,
                          pero también ha aprendido otras cosas fundamentales
                          para sí mismo, la familia y la comunidad.
                        </p>
                        <h3 className="testimonial-title">César Herrera</h3>
                      </div>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <div className="testimonial">
                      <div className="pic">
                        <img
                          src={testimonial_pic2}
                          className="d-block w-50"
                          alt="..."
                        ></img>
                      </div>
                      <div className="testimonial-content">
                        <p className="description">
                          Jennifer Hernández, vive en la comunidad rural Pilas
                          orientales de Masaya, a sus 19 años ella ha sido
                          protagonista del proyecto EMPUJE, el cual conoció
                          acerca del proyecto luego que una promotora
                          comunitaria le comentará sobre la convocatoria y las
                          oportunidades de formación que Children Believe estaba
                          promoviendo.
                        </p>
                        <p className="description">
                          En retrospectiva Jennifer se veía como una joven muy
                          tímida, con dificultades para expresarse con los demás
                          y manejar sus emociones. Mediante su participación en
                          el EMPUJE estuvo en el curso de Habilidades Para la
                          Vida, bootcamps y actividades de intercambio con el
                          sector empresarial, así como con el apoyo de los
                          mentores. Ahora Jennifer, reconoce que ha podido hacer
                          cambios en su vida como el organizarse de mejor
                          manera, manejar sus finanzas y aprender a manejar sus
                          emociones, identificando que ahora se cuenta con
                          capacidades para la empleabilidad y habilidades
                          desarrolladas para desempeñarse en un puesto de
                          trabajo.
                        </p>
                        <p className="description">
                          EMPUJE le brindó la oportunidad de realizar sus
                          pasantías en una Cafetería en donde posteriormente
                          ella quedo contratada de manera fija. Manifiesta que
                          “Ahora que estoy trabajando tengo contactos con muchas
                          personas, gerentes de distribuidoras... que me
                          preguntan si me gustaría trabajar, continuar con mi
                          formación… se sienten cómodos con la atención que es
                          brindé”
                        </p>
                        <h3 className="testimonial-title">
                          Jennifer Hernández{" "}
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <div className="testimonial">
                      <div className="pic">
                        <img
                          src={testimonial_pic3}
                          className="d-block w-50"
                          alt="..."
                        ></img>
                      </div>
                      <div className="testimonial-content">
                        <p className="description">
                          Alberto González, de 29 años de Masaya es un joven que
                          había emigrado hacia Costa Rica en búsqueda de
                          oportunidades laborales y con la pandemia regresó a
                          Nicaragua. En ese momento escuchó sobre Empuje por una
                          amiga que publicó en su whatsapp el link del curso de
                          Habilidades para la Vida de EMPUJE, lo cual le llamo
                          la atención la oportunidad de formarse gratuitamente y
                          procedió a registrarse.
                        </p>
                        <p className="description">
                          Antes de EMPUJE, Alberto se encontraba desempleado y
                          no tenía conocimientos para poder buscar empleo. Con
                          EMPUJE participó en cursos virtuales, webinar y
                          eventos de intercambios con la empresa privada. Obtuvo
                          conocimientos sobre su preparación para el empleo de
                          curriculum, la entrevista, herramientas para
                          prepararse para retener un empleo, proactividad,
                          trabajo en equipo.
                        </p>

                        <p className="description">
                          EMPUJE le permitió hacer una pasantía en el área
                          administrativa en un restaurante local, cuyo dueño
                          participó en los eventos del proyecto y brindó la
                          oportunidad a jóvenes. Este trabajo le ha permitido
                          apoyar a su familia y sus dos hijos, y le ha permitido
                          tener sueños en seguirse desarrollando y ha comenzado
                          sus estudios universitarios en contabilidad.
                        </p>
                        <h3 className="testimonial-title">Alberto González</h3>
                      </div>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <div className="testimonial">
                      <div className="pic">
                        <img
                          src={testimonial_pic4}
                          className="d-block w-50"
                          alt="..."
                        ></img>
                      </div>
                      <div className="testimonial-content">
                        <p className="description">
                          Ana García, de 28 años de Managua. Ana se consideraba
                          que estaba sin motivación personal, se sentía en una
                          zona de confort. En EMPUJE, tuvo la oportunidad de
                          participar en el curso de Habilidades para la vida,
                          Webinars, en un Campamento y en actividades en el
                          marco de KREZCO, así como el curso de contabilidad
                          tributaria.
                        </p>
                        <p className="description">
                          Se empoderó como mujer y logró desarrollar sus
                          habilidades personales. Su familia la ve mucho más
                          activa con motivación personal y planes de vida. Ahora
                          siente que tiene su espíritu emprendedor para poner en
                          marcha su emprendimiento de Barra de uñas.
                        </p>
                        <p className="description">
                          “Creo mucho en la formación personal y profesional,
                          cuando estamos pensando en emprender no es fácil por
                          el tipo de economía. Mi emprendimiento fue de la mano
                          con EMPUJE. Uno de mis sueños es darles oportunidad a
                          otras chavalas de ayudar a sus familias, no que sean
                          empleadas sino proveedoras...en mi caso ayudar a mi
                          mamá”
                        </p>
                        <p className="description">
                          Una de las barreras que enfrente es que tenía que
                          estar al cuidado de mi mamá, quien se enfermó, pero
                          EMPUJE le daba como un escape y en donde aprendió de
                          la resiliencia y pudo sobrellevar ese momento difícil.
                          Ahora su madre está mejor de salud y es una de las
                          personas que la más la motiva en salir adelante en su
                          vida.
                        </p>
                        <h3 className="testimonial-title">Ana García</h3>
                      </div>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <div className="testimonial">
                      <div className="pic">
                        <img
                          src={testimonial_pic5}
                          className="d-block w-50"
                          alt="..."
                        ></img>
                      </div>
                      <div className="testimonial-content">
                        <p className="description">
                          Rosibel Sánchez, es originaria de la comunidad
                          Samulalí #1, de San Ramón, Matagalpa. Tiene 26 años.
                          Ella ha iniciado un emprendimiento de pollos de
                          engorde para la venta de pollo fresco en su comunidad,
                          pues los puestos de venta solo ofrecen pollo
                          congelado.
                        </p>
                        <p className="description">
                          Refiere que el proyecto le ha ayudado a ganar
                          autoconfianza y a salir de su zona de confort. “Con el
                          proyecto me siento más segura, con ideas propias, con
                          deseos de independizarme, he obtenido conocimientos
                          que pongo en práctica. Solo trabajaba por periodos y
                          ahora tengo espíritu emprendedor, pienso fortalecer
                          más esas ganas de mejorar”.
                        </p>
                        <p className="description">
                          “Estoy en un curso de Elaboración de Postres Gourmet
                          en el INATEC, a través del proyecto. Me gusta porque
                          tengo más ideas para más negocios. Estoy realizando
                          mis sueños como mujer emprendedora, he aprendido que
                          todos somos iguales que valemos mucho, que se puede
                          ser dueño de su negocio, aprendí de las brechas de
                          género que la mujeres también tienen derechos, cosas
                          de violencia, relaciones interpersonales,
                          masculinidades positivas”.
                        </p>
                        <h3 className="testimonial-title">Rosibel Sánchez</h3>
                      </div>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <div className="testimonial">
                      <div className="pic">
                        <img
                          src={testimonial_pic6}
                          className="d-block w-50"
                          alt="..."
                        ></img>
                      </div>
                      <div className="testimonial-content">
                        <p className="description">
                          Deyra Mora es una joven granadina que ha demostrado
                          que las barreras de género no le impiden desarrollar
                          su sueño de trabajar en un trabajo tradicionalmente
                          masculino, el remolque de yates y el servicio de
                          lanchas turísticas.
                        </p>
                        <p className="description">
                          Ella tiene 24 años, conoce el proyecto por su mamá,
                          “me gustó que el proyecto me ayudó a reconocer la
                          igualdad de género, me siento empoderada. EMPUJE me
                          ayudó a no limitarme”. Comenta que “Soy afortunada de
                          ser parte del proyecto EMPUJE, sé que mujeres y
                          hombres tienen igualdad de derechos”.
                        </p>
                        <p className="description">
                          Refiere que tuvo que enfrentar las estigmatizaciones
                          en la familia y con los clientes; “El negocio de mi
                          familia es un garaje de yates y ofrecer lanchas
                          turísticas, mis hermanos decían que yo no iba a poder,
                          y mi papá me decían que no podría manejar la camioneta
                          para remolcar los yates, incluso los dueños de los
                          yates tenían desconfianza, pero yo me lo propuse y
                          ahora tienen confianza en mí, me fajo a manejar
                          vehículos pesados al destino que sea”.
                        </p>
                        <h3 className="testimonial-title">Deyra Mora</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExampleControls"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExampleControls"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* seccion de ultimas publicaciones de blog, eliminada hasta nuevo aviso
      <section className="news">
      <div className="title">Últimas Publicaciones</div>
        <div className="container" >      
        <div className="row">                   
          <div className="leerMas">                       
              <a href="https://cep.empuje.org/blog/" target="_blank"  > Leer Mas</a>
            </div> */}
      {/*
            <div className="col-sm-4">
              <img src={blog1} alt="blog1"></img>
              <span>10 de Octubre, 2020</span>
              <h2>¿Cómo ejercer un buen liderazgo?</h2>
              <p>
                En estos tiempos es imposible decir que no conocemos líderes,
                porque en realidad, cada persona posee un espíritu de liderazgo
                que ejerce en cierto ámbito de su vida, no obstante, puede que
                unas veces se perciba más que en otras ocasiones.
              </p>
              <a>Leer más</a>
            </div>

            <div className="col-sm-4">
              <img src={blog2} alt="blog2"></img>
              <span>09 de Octubre, 2020</span>
              <h2>Desarrollo del pensamiento creativo</h2>
              <p>
                Seguramente en varias situaciones de tu vida te han dicho “Sé
                más creativa, sé más creativo”, o bien, “pon tu imaginación a
                volar”, “inspírate” entre otros comentarios relacionados a tu
                creatividad, y es que la mayoría sabe que no es fácil ser
                creativo para los demás, pero tampoco imposible.
              </p>
              <a href="#">Leer más</a>
            </div>

            <div className="col-sm-4">
              <img src={blog3} alt="blog3"></img>
              <span>12 de Octubre, 2020</span>
              <h2>Ventajas y desventajas del trabajo remoto</h2>
              <p>
                Cada día son más empresas que optan por brindar trabajos desde
                casa, a esta práctica se le conoce como trabajo remoto, a la
                prestación de servicios subordinada que realiza un/a trabajador
                que se encuentra físicamente en su domicilio o en el lugar de
                aislamiento domiciliario.
              </p>
              <a href="#">Leer más</a>
</div>
          </div>
          
        </div>
      </section>*/}

      <FooterHome></FooterHome>
    </Fragment>
  );
}

export default Home;
